/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';

@Injectable({
  providedIn: 'root',
})
export class BydProjectUsersService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Attach user to project.
   *
   * @param projectId the project id
   * @param userId the user id
   * @returns Observable<boolean>
   */
  public attachUserToProject(projectId: number, userId: number): Observable<boolean> {
    this.path = `/projects/${projectId}/users/${userId}`;
    return this.post();
  }

  /**
   * Remove user from project.
   *
   * @param projectId the project id
   * @param userId the user id
   * @returns Observable<boolean>
   */
  removeUserFromProject(projectId: number, userId: number): Observable<boolean> {
    this.path = `/projects/${projectId}/users/${userId}`;
    return this.delete();
  }

  /**
   * Implement inherited abstract member 'createNewInstance' from BydRhsAbstractService.
   */
  public createNewInstance() {}
}
